import React from "react";
import {ClaimStatuses} from "../../../types/travelClaims";
import UnreadMessages from "../../../assets/chat_messages.svg";
import UnreadMessagesRed from "../../../assets/chat_messages_red.svg";
import UnreadMessagesBlue from "../../../assets/chat_messages_blue.svg";

export const getClaimStatus = (status: ClaimStatuses) => {
    switch (status) {
        case 'IN_WORK':
            return <ClaimStatusInWork/>
        case 'FINISHED':
        case 'ISSUED':
            return <ClaimStatusCompleted/>
        case 'DRAFT':
            return <ClaimStatusDraft/>
        case 'REGISTERED':
            return <ClaimStatusRegistered/>
        case 'COORDINATING':
            return <ClaimStatusCoordinating/>
        case'APPROVED':
            return <ClaimStatusApproved/>
        case 'POSTPONED':
            return <ClaimStatusPostponed/>
        case 'NEW':
            return <ClaimStatusNew/>
    }
}

type Params = {
    count: number,
    useBg?: boolean,
    height?: number,
    claimStatus: ClaimStatuses | null
}
export const getUnreadMessages = ({count, useBg = true, height = 8, claimStatus}: Params) => {
    let bgClass = useBg ? 'bg-melon-light ' : '';
    let textClass = '';
    let icon = UnreadMessages;
    const heightClass = ' h-' + height;
    const widthClass = ' w-' + height * 2;
    // новый статус синий но непрочитанные важнее красный должен перебивать синий
    if (claimStatus === 'NEW') {
        bgClass = ' bg-blue-200 '
        icon = UnreadMessagesBlue;
        textClass = ' text-blue-500 '
    }
    if (count) {
        bgClass = useBg ? ' bg-red-200 ' : ''
        icon = UnreadMessagesRed;
        textClass = ' text-red-500 '
    }
    return (
        <div className={'flex justify-center rounded-lg text-sm  ' + bgClass + textClass + heightClass + widthClass}>
            <div className='flex flex-row justify-center items-center'>
                <img
                    className='inline-block w-5 h-5'
                    src={icon}
                    alt='Unread messages'
                />
                {count ? count : ''}
            </div>
        </div>
    )
}

export const ClaimStatusInWork = () => {
    return (
        <div
            className="inline-flex items-center justify-center gap-2.5 px-4 py-2 relative flex-[0_0_auto]  bg-[#f6f5c9] rounded-lg">
            <div
                className="
                    relative
                    w-fit
                    whitespace-nowrap
                    text-[#FCD700]
                    font-manager-acrom-ph-14-medium-acrom
                    leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                    text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                    [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                    tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                    font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
            ">
                В работе
            </div>
        </div>
    );
}

export const ClaimStatusCompleted = () => {
    return (
        <div
            className="inline-flex items-center justify-center gap-2.5 px-4 py-2 relative flex-[0_0_auto] bg-statusapplicationbgcompleted rounded-lg">
            <div
                className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-statusapplicationtextcompleted text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Завершено
            </div>
        </div>
    );
}

export const ClaimStatusDraft = () => {
    return (
        <div
            className="inline-flex items-center justify-center gap-2.5 px-4 py-2 relative flex-[0_0_auto] bg-statusapplicationbgdraft rounded-lg">
            <div
                className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-statusapplicationtextdraft text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Черновик
            </div>
        </div>
    );
}

export const ClaimStatusPostponed = () => {
    return (
        <div
            className="inline-flex items-center justify-center gap-2.5 px-4 py-2 relative flex-[0_0_auto] bg-statusapplicationbgdraft rounded-lg">
            <div
                className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-statusapplicationtextdraft text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Отложено
            </div>
        </div>
    );
}

export const ClaimStatusNew = () => {
    return (
        <div
            className="
            inline-flex
            items-center
            justify-center
            gap-2.5
            px-4
            py-2
            relative
            flex-[0_0_auto]
            bg-statusapplicationbgin-work
            rounded-lg">
            <div
                className="
                relative w-fit
                font-manager-acrom-ph-14-medium-acrom
                whitespace-nowrap
                text-statusapplicationtextin-work
                leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                ">
                Новая
            </div>
        </div>
    );
}

export const ClaimStatusRegistered = () => {
    return (
        <div
            className="inline-flex items-center justify-center gap-2.5 px-4 py-2 relative flex-[0_0_auto] bg-statusapplicationbgissued rounded-lg">
            <div
                className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-statusapplicationtextissued text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Подтверждено
            </div>
        </div>
    );
}

// TODO уточнить при каком статусе
export const ClaimStatusCoordinating = () => {
    return (
        <div
            className="inline-flex items-center justify-center gap-2.5 px-4 py-2 relative flex-[0_0_auto] bg-statusapplicationbgcoordination rounded-lg">
            <div
                className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-statusapplicationtextcoordination text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                На согласовании
            </div>
        </div>
    );
}

// TODO уточнить при каком статусе
export const ClaimStatusApproved = () => {
    return (
        <div
            className="inline-flex items-center justify-center gap-2.5 px-4 py-2 relative flex-[0_0_auto] bg-statusapplicationbgapproved rounded-lg">
            <div
                className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-statusapplicationtextapproved text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Утверждено
            </div>
        </div>
    );
}